/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Question_2Inputs */

const en_help_center__payments_n_refunds__question_2 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Question_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I get a refund on my entry price?`)
};

/**
* | output |
* | --- |
* | "Can I get a refund on my entry price?" |
*
* @param {Help_Center__Payments_N_Refunds__Question_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__question_2 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Question_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Question_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__question_2(inputs)
});